export const openExternalLink = (url: string) => {
  const path = url.trim();
  return !path || window.open(path, '_blank', 'noopener,noreferrer');
};
